'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /jobvolume/donatenodeweb-ci-9488/workspace/Release/~/react/react.js
 ** module id = 3
 ** module chunks = 0 1 2 3 4 5 6
 **/